import React from 'react'

// TODO this will seldom be seen.

export default function LoadingBelowFold() {
    return <p />
}
